import { PanZoom } from '../../../view/PanZoom';
import { ModifierKeys } from '../../ModifierKeys';
import { Tool } from '../../Tool';
import { PanAction } from '../../actions/PanAction';
import { ZoomAction } from '../../actions/ZoomAction';

/**
 * {@link DrawingTool} is a common abstraction for all {@link Tool Tools} that are used for drawing contours.
 */
export abstract class DrawingTool extends Tool {
    protected _panAction: PanAction;
    protected _zoomAction: ZoomAction;
    /**
     * {@link DrawingTool} constructor that takes a {@link PanZoom}-object as a parameter.\
     * This {@link PanZoom}-object is used to provide default {@link PanAction Panning} and {@link ZoomAction Zooming} functionality.\
     * {@link PanAction} is bound to mouse middle button without any {@link ModifierKeys}.\
     * {@link ZoomAction} is bound to wheel with {@link ModifierKeys.CTRL CTRL} as a {@link ModifierKeys ModifierKey}.
     * @param panZoom {@link PanZoom}-object that is used to provide default {@link PanAction Panning} and {@link ZoomAction Zooming} functionality.
     */
    protected constructor(panZoom: PanZoom) {
        super();
        this._panAction = new PanAction(panZoom, 1);
        this._zoomAction = new ZoomAction(panZoom, ModifierKeys.CTRL);
    }
}
